import { asyncComponent } from '../../hoc'

export const Map = asyncComponent(() => import('./Map'))
export const MapNarrator = asyncComponent(() => import('./MapNarrator'))
